<template>
  <LoadingGlobalSyncOverlay v-if="isLoadingGlobalApp" />
  <router-view v-else-if="isPublicDisplayRoute" />
  <template v-else>
    <div class="d-flex flex-column flex-root" :class="{ 'cores-botoes-originais': preservarCoresBotoes }">
      <div class="page d-flex flex-row flex-column-fluid">
        <ASideLeft :updateExists="updateExists" @refreshApp="refreshApp" />
        <div 
          class="wrapper d-flex flex-column flex-row-fluid" 
          id="kt_wrapper" 
          :style="{ 'padding-top': appModoTotem ? '10px' : '' }"
        >
          <HeaderTop />
          <ContentMain />
          <FooterBottom />
        </div>
      </div>
    </div>
    <ActivitiesDrawer />
    <ChatDrawer />
    <DemosDrawer />
    <HelpDrawer />
    <ScrollTop />
    <InviteFriends />
    <UsersSearch />
    <UsuariosOnline ref="modalUsuariosOnline" />
    <OfflineSyncOverlay />
    <PendingSignaturesPanel 
      :position-index="0"
    />
    <SenhasTotemPanel 
      :position-index="0"
    />
    <ModalBase ref="idleTimeoutModal" :fullscreen="true">
      <img 
        src="/assets/media/illustrations/dozzy-1/17.png" 
        style="margin: 0 auto; display: block; height: 420px; margin-bottom: 20px;"
      />
      <h1 style="text-align: center;">
        <span class="indicator-label">
          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          Você está inativo por {{ periodoInatividade }} minutos. Você será desconectado em {{ segundosLogout }} segundos.
        </span>
      </h1>
    </ModalBase>
  </template>
</template>

<script>
import moment from "moment";
import { markRaw } from "vue";

import ASideLeft from "@/../../desk-spirit/src/components/ASideLeft";
import HeaderTop from "@/../../desk-spirit/src/components/HeaderTop";
import ContentMain from "@/../../desk-spirit/src/components/ContentMain";
import FooterBottom from "@/../../desk-spirit/src/components/FooterBottom";

import DemosDrawer from "@/../../desk-spirit/src/components/DemosDrawer";
import ChatDrawer from "@/../../desk-spirit/src/components/ChatDrawer";
import ActivitiesDrawer from "@/../../desk-spirit/src/components/ActivitiesDrawer";
import HelpDrawer from "@/../../desk-spirit/src/components/HelpDrawer";
// import EngageToolbar from "@/../../desk-spirit/src/components/EngageToolbar";
import ScrollTop from "@/../../desk-spirit/src/components/ScrollTop";
import InviteFriends from "@/../../desk-spirit/src/components/modals/InviteFriends";
import UsersSearch from "@/../../desk-spirit/src/components/modals/UsersSearch";
import UsuariosOnline from "@/../../desk-spirit/src/components/modals/UsuariosOnline";
import OfflineSyncOverlay from "@/../../desk-spirit/src/components/OfflineSyncOverlay";
import LoadingGlobalSyncOverlay from "@/../../desk-spirit/src/components/LoadingGlobalSyncOverlay";
import PendingSignaturesPanel from "@/../../desk-spirit/src/components/PendingSignaturesPanel.vue";
import SenhasTotemPanel from "@/../../desk-spirit/src/components/SenhasTotemPanel.vue";

import { mapGetters, mapActions } from "vuex";

import { useToast } from "vue-toastification";

import { useIdle } from "@vueuse/core";

import ModalBase from '@/../../desk-spirit/src/components/modals/ModalBase.vue';

import JwtService from "@/core/services/jwt.service";

export default {
  name: "App",
  components: {
    ASideLeft,
    HeaderTop,
    ContentMain,
    FooterBottom,
    DemosDrawer,
    ChatDrawer,
    ActivitiesDrawer,
    HelpDrawer,
    // EngageToolbar,
    ScrollTop,
    InviteFriends,
    UsersSearch,
    UsuariosOnline,
    OfflineSyncOverlay,
    LoadingGlobalSyncOverlay,
    PendingSignaturesPanel,
    SenhasTotemPanel,
    ModalBase
  },
  data() {
    return {
      firstConnect: true, 
      periodoInatividade: 60, 
      intervalIdle: null, 
      timeoutLogout: null, 
      idleObject: {}, 
      segundosLogout: 10, 
      refreshing: false, 
      registration: null, 
      updateExists: false, 
      checkTimer: null, 
      isLoadingGlobalApp: true,
      
      pendingDocuments: [{
        id: 101,
        title: 'Prescrição médica',
        patientName: 'João da Silva',
        type: 'Receita',
        description: 'Consulta oftalmológica',
        createdAt: '2026-08-18T17:20:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 102,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 103,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 104,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 105,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 106,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 107,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 108,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      },{
        id: 109,
        title: 'Atestado médico',
        patientName: 'Maria Oliveira',
        type: 'Atestado',
        description: 'Atendimento clínico',
        createdAt: '2026-08-18T17:31:00-03:00',
        signing: false,
        discarding: false
      }]
    };
  },
  sockets: {
    connect() {
      this.updateAppOnline(true);

      if (this.firstConnect) {
        this.firstConnect = false;
      } else {
        if(this.avisaOnlineOffline) {
          const toast = useToast();

          toast.success("Você foi reconectado a internet!", {
            position: "bottom-center",
            timeout: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });
        }
      }
    },
    disconnect() {
      this.updateAppOnline(false);

      if(this.avisaOnlineOffline) {
        const toast = useToast();

        toast.error("Você foi desconectado da internet!", {
          position: "bottom-center",
          timeout: 5000,
          closeOnClick: true,
          pauseOnFocusLoss: true,
          pauseOnHover: true,
          draggable: true,
          draggablePercent: 0.6,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false
        });
      }
    },
    async logout() {
      await this.$swal({
        icon: "warning",
        text: "Seu usuário foi conectado em outra instância, você será deslogado nesta aba.",
        timer: 3000,
        timerProgressBar: true
      });

      window.onbeforeunload = null;
      this.logout();
    }, 
    async realizarAgendamento(dados) {
      if((this.$route.name != "agenda") && (this.$route.name != "agendaGoogle")) {
        this.$router.push({ name: "agenda" });

        await this.sleepTime(3000);

        this.emitter.emit("realizarAgendamentoEmit", dados);
      }
    }
  },
  created() {
    document.addEventListener(
      "swUpdated", this.showRefreshUI, { once: true }
    );
    document.addEventListener(
      "swCached", this.showRefreshUICached, { once: true }
    );
    if(navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener(
        "controllerchange", () => {
          if (this.refreshing) return;
          this.refreshing = true;
          window.location.reload();
        }
      );
    }
  },
  async mounted() {
    await this.$router.isReady();
    await this.sleepTime(500);

    this.isLoadingGlobalApp = false;

    await this.sleepTime(100);

    this.iniciarKTMetronic();

    if(this.isPublicDisplayRoute) {
      window.onbeforeunload = null;
      if (this.$route.meta.layout !== "checkout") {
        JwtService.destroyToken();
        JwtService.destroySistema();
      }
    } else {
      this.atualizarLoadingPerfil(true);
      let validacao = await this.getValidateToken();
      this.atualizarLoadingPerfil(false);

      if(!validacao.resultado) {
        this.logout();
      }

      window.addEventListener("online", () => {
        this.updateAppBrowserOnline(true);
      });

      window.addEventListener("offline", () => {
        this.updateAppBrowserOnline(false);
      });

      await this.$nextTick();
      
      await this.getAvatar(this.idEmitenteMLUsuario);

      let periodoMaximoInatividade = await this.getConfiguracaoMaster({
        CONTEUDO_NOME: "CONTEUDO", 
        NIVEL: "1", 
        OPERACAO: "C", 
        USUARIO: "GERAL", 
        SISTEMA: "GERAL", 
        MODULO: "LOGIN", 
        CAMPO: "PERIODO_MAXIMO_INATIVIDADE", 
        CONTEUDO: ""
      });

      if (periodoMaximoInatividade.CONTEUDO) {
        this.periodoInatividade = parseInt(periodoMaximoInatividade.CONTEUDO);
      }

      this.emitter.on("acessarUsuariosOnline", () => {
        this.$refs.modalUsuariosOnline.toggleModal();
      });

      this.$socket.emit("usuariosOnline", {});

      this.idleObject = useIdle(this.periodoInatividade * 60 * 1000);

      this.intervalIdle = setInterval(() => {
        if ((this.$route.name != "chamadaNaTV") && (this.$route.name != "totemPaciente")) {
          if (this.idleObject.idle) {
            if ((this.$refs.idleTimeoutModal) && (!this.$refs.idleTimeoutModal.showModal)) {
              this.segundosLogout = 10;
              this.$refs.idleTimeoutModal.toggleModal();
              this.timeoutLogout = setTimeout(() => {
                window.onbeforeunload = null;
                this.logout();
              }, 10000);
            } else if (this.segundosLogout > 0) {
              this.segundosLogout--;
            }
          } else {
            if ((this.$refs.idleTimeoutModal) && (this.$refs.idleTimeoutModal.showModal)) {
              this.$refs.idleTimeoutModal.toggleModal();
              clearTimeout(this.timeoutLogout);
            }
          }
        }
      }, 1000);

      window.addEventListener("message", (event) => {
        if((event.origin == "https://www.facebook.com") || (event.origin == "https://web.facebook.com")) {
          try {
            const data = JSON.parse(event.data);

            if(data.type === "WA_EMBEDDED_SIGNUP") {
              if(data.event.indexOf("FINISH") >= 0) {
                const {business_id, phone_number_id, waba_id} = data.data;
                this.emitter.emit("waEmbeddedSignupFinish", {business_id, phone_number_id, waba_id});
              }
            }
          } catch (error) {
            console.error(error);
            console.log(event.data);
          }
        }
      });

      this.checkTimer = setInterval(() => {
        this.checkApiStatus();
      }, 30000);

      this.getConfiguracaoCamposHorarios();
    }
  }, 
  beforeUnmount() {
    window.removeEventListener("swUpdated");
    window.removeEventListener("swCached");
    if(navigator.serviceWorker) {
      navigator.serviceWorker.removeEventListener("controllerchange");
    }
    this.emitter.off("acessarUsuariosOnline");
    window.removeEventListener("online");
    window.removeEventListener("offline");
    window.removeEventListener("message");
    if(this.intervalIdle) {
      clearInterval(this.intervalIdle);
    }
    if(this.checkTimer) {
      clearInterval(this.checkTimer);
    }
  }, 
  computed: {
    preservarCoresBotoes() {
      const rota = String(this.$route.name || '');
      return ['agenda', 'agendaGoogle', 'filaPep', 'filaLaudo', 'filaExames'].includes(rota) || rota.startsWith('pep');
    },
    ...mapGetters([
      "idEmitenteMLUsuario", 
      "appModoTotem", 
      "avisaOnlineOffline"
    ]), 
    isPublicDisplayRoute() {
      return this.$route.meta.layout === "checkout" || this.$route.meta.layout === "display" || this.$route.meta.deviceRoute === true;
    }
  },
  methods: {
    ...mapActions([
      "getValidateToken", 
      "logout", 
      "updateAppOnline", 
      "updateAppBrowserOnline", 
      "getAvatar", 
      "getConfiguracaoMaster", 
      "atualizarLoadingPerfil", 
      "sleepTime", 
      "checkApiStatus", 
      "iniciarKTMetronic", 
      "getConfiguracaoCamposHorarios"
    ]),
    showRefreshUI(e) {
      this.registration = markRaw(e.detail);
      this.updateExists = true;
    },
    showRefreshUICached() {
      this.updateExists = true;
    },
    async refreshApp() {
      this.updateExists = false;

      console.log("Atualizando...");

      if ((this.registration) && (this.registration.waiting)) {
        this.registration.waiting.postMessage("skipWaiting");
      }
      await this.sleepTime(3000);

      window.location.reload(true);
    }, 
    formataDataSimples(data) {
      if(this.$i18n.locale == "en") {
        return moment(data, "YYYY-MM-DD").format("MM/DD/YYYY");
      } else if(this.$i18n.locale == "es") {
        return moment(data, "YYYY-MM-DD").format("MM/DD/YYYY");
      } else {
        return moment(data, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
    }, 
    formataDataComHoraSimples(data) {
      if(this.$i18n.locale == "en") {
        return moment(data, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY");
      } else if(this.$i18n.locale == "es") {
        return moment(data, "YYYY-MM-DD HH:mm:ss").format("MM/DD/YYYY");
      } else {
        return moment(data, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY");
      }
    }
  }
}
</script>

<style src="@/assets/css/menus-desabilitados.css"></style>
<style src="@/assets/css/filtros-botoes.css"></style>
<style src="@/assets/css/tabela-acoes.css"></style>
<style>
.content {
  padding-bottom: 100px;
}

label.fs-6.fw-semibold.form-label.mt-3 {
  margin-top: 0 !important;
}

#confetti-canvas {
  z-index: 1003;
}

.tempus-dominus-widget {
  margin: 0 auto;
}

.swal2-container {
  z-index: 100000 !important;
}

.hg-button.hg-standardBtn {
  font-size: 24px;
}

.hg-button.hg-functionBtn.hg-button-bksp {
  font-size: 18px;
}

.container-xxl {
  padding-bottom: 40px;
}

.tempus-dominus-widget.light .date-container-days div.day.active {
  background-color: inherit;
  color: var(--bs-gray-900);
  text-shadow: none;
}

#pepAnchorPoint {
  margin: 0px 0px !important;
}

svg>g>g.google-visualization-tooltip {
  pointer-events: none
}

.symbol-group .symbol {
  margin-left: -8px;
}

.animate__animated {
  -webkit-animation-fill-mode: none !important;
  animation-fill-mode: none !important;
}

.cke_notifications_area {
  display: none !important;
}

.bg-medicamento {
  background-color: #66afb3 !important;
}

.bg-receituario {
  background-color: #66afb3 !important;
}

.bg-consulta {
  background-color: #8100f7 !important;
}

.bg-exame {
  background-color: #00bef7 !important;
}

.bg-cirurgia {
  background-color: #f77d00 !important;
}

.bg-solicitacao {
  background-color: #004ef7 !important;
}

.bg-agenda-retorno {
  background-color: #a900f7 !important;
}

@media print {
  body {
    background-color: white !important;
  }

  #kt_wrapper {
    padding-top: 0 !important;
  }

  #kt_aside {
    display: none !important;
  }

  #kt_header {
    display: none !important;
  }

  #kt_footer {
    display: none !important;
  }

  .scrolltop-btn {
    display: none !important;
  }

  #kt_content {
    padding: 0 !important;
  }

  #container-pep {
    padding: 0 !important;
  }

  .container-atendimento-2 {
    display: block !important;
  }

  .card-lateral-pep {
    border-radius: 0 !important;
  }

  .card-lateral-pep-toolbar {
    display: none !important;
  }

  .pep-botoes-atendimento {
    display: none !important;
  }

  .pep-aviso-mensagem {
    display: none !important;
  }

  .container-atendimento-2-graficos {
    display: none !important;
  }

  .filtros-timeline-pep {
    display: none !important;
  }

  .cabecalho-impressao-pep {
    display: block !important;
  }

  #menuPEPLateral {
    display: none !important;
  }

  .card-historico-atendimento {
    padding: 0 !important;
    border-radius: 0 !important;
  }

  #pepAnchorPoint {
    margin: 0 !important;
  }

  .card-timeline-header {
    padding: 0 0.5rem !important;
  }

  .card-timeline-header .card-toolbar {
    display: none !important;
  }

  .card-timeline-body {
    padding: 1rem 0.5rem !important;
  }

  .btn-imprimir-pep {
    display: none !important;
  }

  .accordion-icon {
    display: none !important;
  }

  .btn-excluir-historico {
    display: none !important;
  }

  .btn-close-historico {
    display: none !important;
  }
}
</style>
